// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProseMirror code {
  caret-color: white; /* caret-white */
  color: white; /* text-white */
  background-color: #1a1a1a; /* bg-neutral-900 */
  border-radius: 0.125rem; /* rounded-sm */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* shadow-lg */
  font-family: monospace; /* font-mono */
}

.ProseMirror code::selection {
  background-color: rgba(255, 255, 255, 0.3); /* bg-white/30 */
}

.ProseMirror pre {
  caret-color: white; /* caret-white */
  background-color: #3f3f46; /* bg-neutral-700 */
  color: white; /* text-white */
  border-radius: 0.25rem; /* rounded */
  margin-top: 3rem; /* my-12 */
  margin-bottom: 3rem; /* my-12 */
  padding: 1rem; /* p-4 */
  border: 1px solid black; /* border-black */
}

.ProseMirror pre.dark {
  background-color: #1a1a1a; /* dark:bg-neutral-900 */
  border-color: #1f2937; /* dark:border-neutral-800 */
}

.ProseMirror pre *::selection {
  background-color: rgba(255, 255, 255, 0.2); /* bg-white/20 */
}

.ProseMirror pre code {
  background-color: inherit; /* bg-inherit */
  color: inherit; /* text-inherit */
  padding: 0; /* p-0 */
  box-shadow: none; /* shadow-none */
}

.ProseMirror pre .hljs-comment,
.ProseMirror pre .hljs-quote {
  color: #9ca3af; /* text-neutral-400 */
}

.ProseMirror pre .hljs-variable,
.ProseMirror pre .hljs-template-variable,
.ProseMirror pre .hljs-attribute,
.ProseMirror pre .hljs-tag,
.ProseMirror pre .hljs-name,
.ProseMirror pre .hljs-regexp,
.ProseMirror pre .hljs-link,
.ProseMirror pre .hljs-selector-id,
.ProseMirror pre .hljs-selector-class {
  color: #f87171; /* text-red-300 */
}

.ProseMirror pre .hljs-number,
.ProseMirror pre .hljs-meta,
.ProseMirror pre .hljs-built_in,
.ProseMirror pre .hljs-builtin-name,
.ProseMirror pre .hljs-literal,
.ProseMirror pre .hljs-type,
.ProseMirror pre .hljs-params {
  color: #fb923c; /* text-orange-300 */
}

.ProseMirror pre .hljs-string,
.ProseMirror pre .hljs-symbol,
.ProseMirror pre .hljs-bullet {
  color: #4ade80; /* text-lime-300 */
}

.ProseMirror pre .hljs-title,
.ProseMirror pre .hljs-section {
  color: #facc15; /* text-yellow-300 */
}

.ProseMirror pre .hljs-keyword,
.ProseMirror pre .hljs-selector-tag {
  color: #2dd4bf; /* text-teal-300 */
}

.ProseMirror pre .hljs-emphasis {
  font-style: italic;
}

.ProseMirror pre .hljs-strong {
  font-weight: 700; /* font-bold */
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/RichTextEditor/src/styles/partials/code.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB,EAAE,gBAAgB;EACpC,YAAY,EAAE,eAAe;EAC7B,yBAAyB,EAAE,mBAAmB;EAC9C,uBAAuB,EAAE,eAAe;EACxC,0CAA0C,EAAE,cAAc;EAC1D,sBAAsB,EAAE,cAAc;AACxC;;AAEA;EACE,0CAA0C,EAAE,gBAAgB;AAC9D;;AAEA;EACE,kBAAkB,EAAE,gBAAgB;EACpC,yBAAyB,EAAE,mBAAmB;EAC9C,YAAY,EAAE,eAAe;EAC7B,sBAAsB,EAAE,YAAY;EACpC,gBAAgB,EAAE,UAAU;EAC5B,mBAAmB,EAAE,UAAU;EAC/B,aAAa,EAAE,QAAQ;EACvB,uBAAuB,EAAE,iBAAiB;AAC5C;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,qBAAqB,EAAE,4BAA4B;AACrD;;AAEA;EACE,0CAA0C,EAAE,gBAAgB;AAC9D;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,cAAc,EAAE,iBAAiB;EACjC,UAAU,EAAE,QAAQ;EACpB,gBAAgB,EAAE,gBAAgB;AACpC;;AAEA;;EAEE,cAAc,EAAE,qBAAqB;AACvC;;AAEA;;;;;;;;;EASE,cAAc,EAAE,iBAAiB;AACnC;;AAEA;;;;;;;EAOE,cAAc,EAAE,oBAAoB;AACtC;;AAEA;;;EAGE,cAAc,EAAE,kBAAkB;AACpC;;AAEA;;EAEE,cAAc,EAAE,oBAAoB;AACtC;;AAEA;;EAEE,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,EAAE,cAAc;AAClC","sourcesContent":[".ProseMirror code {\n  caret-color: white; /* caret-white */\n  color: white; /* text-white */\n  background-color: #1a1a1a; /* bg-neutral-900 */\n  border-radius: 0.125rem; /* rounded-sm */\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* shadow-lg */\n  font-family: monospace; /* font-mono */\n}\n\n.ProseMirror code::selection {\n  background-color: rgba(255, 255, 255, 0.3); /* bg-white/30 */\n}\n\n.ProseMirror pre {\n  caret-color: white; /* caret-white */\n  background-color: #3f3f46; /* bg-neutral-700 */\n  color: white; /* text-white */\n  border-radius: 0.25rem; /* rounded */\n  margin-top: 3rem; /* my-12 */\n  margin-bottom: 3rem; /* my-12 */\n  padding: 1rem; /* p-4 */\n  border: 1px solid black; /* border-black */\n}\n\n.ProseMirror pre.dark {\n  background-color: #1a1a1a; /* dark:bg-neutral-900 */\n  border-color: #1f2937; /* dark:border-neutral-800 */\n}\n\n.ProseMirror pre *::selection {\n  background-color: rgba(255, 255, 255, 0.2); /* bg-white/20 */\n}\n\n.ProseMirror pre code {\n  background-color: inherit; /* bg-inherit */\n  color: inherit; /* text-inherit */\n  padding: 0; /* p-0 */\n  box-shadow: none; /* shadow-none */\n}\n\n.ProseMirror pre .hljs-comment,\n.ProseMirror pre .hljs-quote {\n  color: #9ca3af; /* text-neutral-400 */\n}\n\n.ProseMirror pre .hljs-variable,\n.ProseMirror pre .hljs-template-variable,\n.ProseMirror pre .hljs-attribute,\n.ProseMirror pre .hljs-tag,\n.ProseMirror pre .hljs-name,\n.ProseMirror pre .hljs-regexp,\n.ProseMirror pre .hljs-link,\n.ProseMirror pre .hljs-selector-id,\n.ProseMirror pre .hljs-selector-class {\n  color: #f87171; /* text-red-300 */\n}\n\n.ProseMirror pre .hljs-number,\n.ProseMirror pre .hljs-meta,\n.ProseMirror pre .hljs-built_in,\n.ProseMirror pre .hljs-builtin-name,\n.ProseMirror pre .hljs-literal,\n.ProseMirror pre .hljs-type,\n.ProseMirror pre .hljs-params {\n  color: #fb923c; /* text-orange-300 */\n}\n\n.ProseMirror pre .hljs-string,\n.ProseMirror pre .hljs-symbol,\n.ProseMirror pre .hljs-bullet {\n  color: #4ade80; /* text-lime-300 */\n}\n\n.ProseMirror pre .hljs-title,\n.ProseMirror pre .hljs-section {\n  color: #facc15; /* text-yellow-300 */\n}\n\n.ProseMirror pre .hljs-keyword,\n.ProseMirror pre .hljs-selector-tag {\n  color: #2dd4bf; /* text-teal-300 */\n}\n\n.ProseMirror pre .hljs-emphasis {\n  font-style: italic;\n}\n\n.ProseMirror pre .hljs-strong {\n  font-weight: 700; /* font-bold */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
